// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class EndRoundAction implements flatbuffers.IUnpackableObject<EndRoundActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EndRoundAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEndRoundAction(bb:flatbuffers.ByteBuffer, obj?:EndRoundAction):EndRoundAction {
  return (obj || new EndRoundAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEndRoundAction(bb:flatbuffers.ByteBuffer, obj?:EndRoundAction):EndRoundAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EndRoundAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.GameEndRound;
}

static startEndRoundAction(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.GameEndRound);
}

static endEndRoundAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEndRoundAction(builder:flatbuffers.Builder, type:ActionType):flatbuffers.Offset {
  EndRoundAction.startEndRoundAction(builder);
  EndRoundAction.addType(builder, type);
  return EndRoundAction.endEndRoundAction(builder);
}

unpack(): EndRoundActionT {
  return new EndRoundActionT(
    this.type()
  );
}


unpackTo(_o: EndRoundActionT): void {
  _o.type = this.type();
}
}

export class EndRoundActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.GameEndRound
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return EndRoundAction.createEndRoundAction(builder,
    this.type
  );
}
}
